/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_LinkInputs */

const en_cap_agents_link = /** @type {(inputs: Cap_Agents_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the agent team case study`)
};

const lv_cap_agents_link = /** @type {(inputs: Cap_Agents_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasīt par aģentu komandu`)
};

/**
* | output |
* | --- |
* | "Read the agent team case study" |
*
* @param {Cap_Agents_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_link = /** @type {((inputs?: Cap_Agents_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_link(inputs)
	return en_cap_agents_link(inputs)
});